import React from "react";
import PropTypes from "prop-types";

const VideoSection = ({section}) => {
  let { content, colour, bgColour, topMargin, bottomMargin, heading } = section;

  return (
    <div className={`wrapper block-wrapper bg-${bgColour} ${topMargin} ${bottomMargin}`}>
      <div className="wrapper--inner flex flex-w-w flex-jc-sb">
        <div className="col-1 col-lg-4-2">
          <div className="video-wrapper">
            <iframe 
              src={content.videoUrl}
              width="640" height="360"
              frameBorder="0"
              allow="fullscreen"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="col-1  col-lg-4-2 ">
          <div className="video">
            <div className="video-copy copy">
              {heading && <h2 className={`h2 color-${colour}`} dangerouslySetInnerHTML={{__html: heading}}></h2>}
              <div dangerouslySetInnerHTML={{__html: content.content}}></div>
            </div>
            {(content.date || content.label) && (
              <div className="video-extra">
                <time>{content.date}</time>
                {content.label && (
                  <div className={`content-label label-${content.labelColour.toLowerCase()}`}>{content.label}</div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}


VideoSection.propTypes = {
  section: PropTypes.object.isRequired
}

export default VideoSection;
